import { Dialog } from "../Catalyst/dialog";
import { Button } from "../Catalyst/button";
import { UploadCSVComponent } from "../pages/UserListDashboard/UploadCSVComponent";
import { SendManuallyComponent } from "../pages/UserListDashboard/SendManuallyComponent";
import FinleyIconName from "../../assets/FinleyIconName";

interface InviteUsersDialogProps {
  orgName: string;
  open: boolean;
  onClose: () => void;
}

// Invite users to an organization via CSV upload or a manual form. Shared by the
// user list dashboard and the Organizations screen (ADM-6 "+ Create" menu); the
// invite components themselves resolve the target org via useOrgId().
const InviteUsersDialog = ({ orgName, open, onClose }: InviteUsersDialogProps) => {
  return (
    <Dialog size="5xl" open={open} onClose={() => {}}>
      <div className="mt-[25px] flex w-full items-center">
        <div className="w-full rounded-lg bg-white shadow-sm">
          <div className="mb-6">
            <Button outline className="h-10 w-18" onClick={onClose}>
              Close
            </Button>
          </div>

          <div className="mb-4 flex items-center gap-2">
            <FinleyIconName />
          </div>

          <h2 className="mb-4 desktext14 text-gray-900">
            Invite users to {orgName} with CSV Upload
          </h2>

          <UploadCSVComponent />

          <div className="my-6 text-start text-sm text-gray-500">OR</div>

          <SendManuallyComponent />
        </div>
      </div>
    </Dialog>
  );
};

export default InviteUsersDialog;
